    import React from 'react';

    class ErrorBoundary extends React.Component {
      constructor(props) {
        super(props);
        this.state = { hasError: false, error: null, errorInfo: null };
      }

      // This method is called after an error has been thrown by a descendant component.
      static getDerivedStateFromError() {
        // Update state so the next render will show the fallback UI.
        return { hasError: true };
      }

      // This method is called after an error has been thrown.
      // It's used for logging error information.
      componentDidCatch(error, errorInfo) {
        // You can log the error to an error reporting service here
        console.error("Error caught by Error Boundary:", error, errorInfo);
        this.setState({
          error: error,
          errorInfo: errorInfo
        });
      }

      render() {
        if (this.state.hasError) {
          // You can render any custom fallback UI
          return (
            <div>
              <h2>Something went wrong.</h2>
              {this.props.fallback || (
                <details style={{ whiteSpace: 'pre-wrap' }}>
                  {this.state.error && this.state.error.toString()}
                  <br />
                  {this.state.errorInfo && this.state.errorInfo.componentStack}
                </details>
              )}
            </div>
          );
        }

        return this.props.children;
      }
    }

    export default ErrorBoundary;